<template>
  <van-dialog
    v-bind="$attrs"
    class-name="protocol-dialog"
    :show-cancel-button="false"
    :show-confirm-button="false"
  >
    <h1>文明上网倡议书</h1>
    <div class="protocol-dialog__content">
      <p>为推动网络文明建设，共建清朗网络空间秩序，共享网络文明成果，我倡议：</p>
      <h3>一、依法上网，做网络文明的建设者</h3>
      <p>
        互联网不是“法外之地”。自觉遵守国家互联网法律法规，坚持依法上网、文明上网，不发布和传播违反国家法律法规、影响国家安全、破坏社会稳定、破坏民族团结和宗教信仰的信息。
      </p>
      <h3>二、安全上网，做网络文明的维护者</h3>
      <p>
        网络安全维系着国家和千家万户安全。自觉履行维护国家安全和网络安全的义务，不传输损害国家安全的文字、图片、视频等内容，不进行攻击网络系统、窃取各种秘密等危害网络安全的不法行为；不随意打开和浏览不明网站，不轻易在网络透露个人隐私和重要身份信息，发现可疑情况及时投诉或举报。
      </p>
      <h3>三、文明上网，做网络文明的传播者</h3>
      <p>
        互联网是传播人类先进文化、弘扬正能量的重要载体。养成良好上网习惯，不信谣、不传谣，不发布、不转发未经官方证实的信息。远离低俗、色情、暴力等不健康网络信息，积极传播网络文明正能量。
      </p>
      <h3>四、绿色上网，做网络文明的践行者</h3>
      <p>
        互联网是人类共同的家园。健康用网、理性用网、绿色上网，对散播谣言、侵犯隐私、侮辱他人、信谣传谣的信息及时删除，不跟风、不炒作，自觉屏蔽不良网站，积极构建和谐健康的网络环境。
      </p>
      <p>
        网络安全事关国家安全、社会和谐、家庭幸福，愿你我携手共建绿色网络空间，奏响网络文明的和谐之音！
      </p>
    </div>
    <div class="protocol-dialog__footer">
      <div style="width: 30%" @click="addCount">
        <van-button type="primary" block class="read-btn" :loading="loading">已阅读</van-button>
      </div>
      <div class="tip-info">已有{{ count }}人阅读了倡议书</div>
    </div>
  </van-dialog>
</template>

<script setup>
import axios from 'axios';
import { Dialog, Button, Toast } from 'vant';
import { watch, defineEmits, ref, useAttrs } from 'vue';

const emits = defineEmits(['readSuccess']);

const VanDialog = Dialog.Component;
const VanButton = Button;
const count = ref();
const loading = ref(false);
const attrs = useAttrs();

// 倡议书点击：https://base.mkzcdn.com/proposal/click/
// 倡议书统计：https://base.mkzcdn.com/proposal/read/
const requestInst = axios.create({
  baseURL: 'https://base.mkzcdn.com'
  // headers: {
  // 'Content-Type': 'application/json'
  // }
});

// 响应拦截器
requestInst.interceptors.response.use(
  response => {
    const data = response.data;
    const { code, message } = data;
    if (code !== '200') {
      Toast(message);
    }
    return data;
  },
  error => {
    // 对响应错误做一些处理
    console.error(error);
    return Promise.reject(error);
  }
);

async function addCount() {
  loading.value = true;
  const { code } = await requestInst.post('/proposal/click/').catch(() => {
    loading.value = false;
  });
  if (code === '200') {
    emits('readSuccess');
  }
  loading.value = false;
}

async function getCount() {
  const { data, code } = await requestInst.get('/proposal/read/').catch(() => {});
  if (code === '200') {
    count.value = data.count;
  }
}

watch(
  () => attrs.show,
  show => {
    if (show) {
      getCount();
    }
  },
  {
    immediate: true
  }
);
</script>

<style lang="scss">
.protocol-dialog {
  --van-dialog-width: 60%;
  --van-dialog-font-size: 30px;
  --van-dialog-border-radius: 12px;

  padding: 30px 30px 60px;
  background-color: #fff;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  h1 {
    font-size: 40px;
    text-align: center;
  }
  h3 {
    font-size: 32px;
    margin: 15px 0;
    font-weight: 600;
  }
  p {
    text-indent: 2em;
    color: #666;
    line-height: 1.5;
    font-size: 28px;
  }
  &__content {
    overflow-y: scroll;
    max-height: 800px;
  }
  &__footer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 40px 0 10px;
    .tip-info {
      font-size: 26px;
      color: #666;
      margin-top: 20px;
    }
    .read-btn {
      font-size: 30px;
      transform: scale(0.85);
      border-radius: 12px;
      width: 100%;
    }
  }
}

@media screen and (max-width: 750px) {
  .protocol-dialog {
    --van-dialog-width: 640px;
  }
}
</style>
